var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, Input, ViewChild } from '@angular/core';
import './popup-entity.component.scss';
import { DeContainerComponent } from "../../../de.container.component";
var PopupEntityComponent = /** @class */ (function () {
    function PopupEntityComponent() {
    }
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], PopupEntityComponent.prototype, "parentContainer", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], PopupEntityComponent.prototype, "formName", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], PopupEntityComponent.prototype, "category", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Number)
    ], PopupEntityComponent.prototype, "formId", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Number)
    ], PopupEntityComponent.prototype, "entityId", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], PopupEntityComponent.prototype, "params", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Boolean)
    ], PopupEntityComponent.prototype, "isToggled", void 0);
    __decorate([
        ViewChild('drawerContainer'),
        __metadata("design:type", DeContainerComponent)
    ], PopupEntityComponent.prototype, "drawerContainer", void 0);
    PopupEntityComponent = __decorate([
        Component({
            moduleId: module.id + '',
            selector: 'popupEntityForm',
            template: require('./popup-entity.component.html'),
        })
    ], PopupEntityComponent);
    return PopupEntityComponent;
}());
export { PopupEntityComponent };
//# sourceMappingURL=popup-entity.component.js.map